import { createSelector } from '@reduxjs/toolkit';
import { SiteFooter } from '../../../types';

export const selectSiteFooter = createSelector(
  [(state) => state.siteFooter as SiteFooter],
  (data) => data.data,
);
